
import { AxiosAdapter } from "../commons/adapters";

const http = new AxiosAdapter();

export const getPlaningShiftRequestService = async () => {
    try {
        return await http.get('/v1/intelligent-scheduling/shift-generator/form-generate-request');
    } catch (error: any) {
        if (error && !error.ok) { 
            return error;
        }
        console.log('getPlaningShiftRequestService ', error);
    }
};



export const generateShiftsService = async (data: any, historicalFile?: File | null) => {
    try {
        if (historicalFile) {
            const formData = new FormData();
            formData.append('id', data.id);
            formData.append('historicalFile', historicalFile);
            
            // Override headers to not set application/json for FormData
            return await http.post('/v1/intelligent-scheduling/shift-generator/generate', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
        }
        return await http.post('/v1/intelligent-scheduling/shift-generator/generate', data);
    } catch (error: any) {
        if (error && !error.ok) { 
            return error;
        }
        console.log('generateShiftsService ', error);
    }
};

export const adjustWithAiService = async (data: any) => {
    try {
        return await http.post('/v1/intelligent-scheduling/shift-generator/adjust-with-ai', data);
    } catch (error: any) {
        if (error && !error.ok) { 
            return error;
        }
        console.log('adjustWithAiService ', error);
    }
};

export const saveDraftService = async (data: any) => {
    try {
        return await http.post('/v1/intelligent-scheduling/shift-generator/save-draft', data);
    } catch (error: any) {
        if (error && !error.ok) { 
            return error;
        }
        console.log('saveDraftService ', error);
    }
};

